<template>
  <div>
    <md-card class="card-container" v-if="isLoaded">
      <div class="md-layout md-gutter">
        <div class="md-layout-item">
          <page-title :title="isEditing ? '修改使用者' : '新增使用者'"></page-title>
        </div>
      </div>
      <div>
        <md-tabs :md-dynamic-height="true">
          <md-tab md-label="基礎資訊">
            <div>
              <div class="md-layout md-gutter">
                <div class="md-layout-item">
                  <md-field>
                    <label>姓名</label>
                    <md-input v-model="data.name"></md-input>
                  </md-field>
                </div>
              </div>
              <div class="md-layout md-gutter">
                <div class="md-layout-item">
                  <md-field>
                    <label>帳號</label>
                    <md-input v-model="data.username"></md-input>
                  </md-field>
                </div>
              </div>
              <div class="md-layout md-gutter">
                <div class="md-layout-item">
                  <md-field>
                    <label>密碼</label>
                    <md-input v-model="data.password" type="password"></md-input>
                  </md-field>
                </div>
              </div>
              <div class="md-layout md-gutter">
                <div class="md-layout-item">
                  <md-field>
                    <label>角色</label>
                    <md-select v-model="data.role.id">
                      <md-option v-for="(role, index) in roles" :roles="roles" :key="role.id" :value="role.id">{{role.name}}</md-option>
                    </md-select>
                  </md-field>
                </div>
              </div>
              <div class="md-layout md-gutter">
                <div class="md-layout-item">
                  <md-field>
                    <label>營業地點</label>
                    <md-select v-model="data.clinic.id">
                      <md-option v-for="(clinic, index) in clinics" :clinics="clinics" :key="clinic.id" :value="clinic.id">{{clinic.name}}</md-option>
                    </md-select>
                  </md-field>
                </div>
              </div>
            </div>
          </md-tab>
          <md-tab md-label="專任治療標籤">
            <div class="md-layout md-gutter" v-for="tag in tags">
              <div class="md-layout-item">
                <md-checkbox v-model="tag.is_dedicated">{{tag.name}}</md-checkbox>
              </div>
            </div>
          </md-tab>
        </md-tabs>
      </div>
      <div class="md-layout md-gutter">
        <div class="md-layout-item">
          <md-button class="md-raised" @click="goUserList">返回</md-button>
          <md-button class="md-raised md-accent" @click="removeUser">刪除使用者</md-button>
        </div>
        <div class="md-layout-item">
          <md-button class="md-raised md-primary float-right" @click="submit">送出</md-button>
        </div>
      </div>
    </md-card>
  </div>
</template>

<script>
import PageTitle from '@/components/Shared/PageTitle'
import axios from 'axios'
import urls from '@/urls'

export default {
  data () {
    return {
      isEditing: null,
      isLoaded: false,
      roles: [],
      clinics: [],
      tags: [],
      data: {
        role: {},
        clinic: {}
      }
    }
  },
  components: {
    PageTitle
  },
  created: async function () {
    if (this.$route.params.id !== 'add') {
      this.isEditing = this.$route.params.id
    }
    await this.getDedicatedTags()
    await this.getRole()
    await this.getClinic()
    if (this.isEditing) {
      this.readUser(this.isEditing)
    }
    this.isLoaded = true
  },
  methods: {
    goUserList () {
      this.$router.push('/user')
    },
    getDedicatedTags: async function () {
      let req = await axios.get(urls({route: 'tag'}), {
        params: {
          dedicated: true
        }
      })
      this.tags = req.data.data.map(i => {
        return { ...i, is_dedicated: false }
      })
    },
    getRole: async function () {
      let req = await axios.get(urls({route: 'role'}))
      this.roles = req.data.data
    },
    submit: async function () {
      let url
      const dedicatedTags = this.tags.filter(i => i['is_dedicated']).map(i => i['id'])
      this.data.dedicatedTag = dedicatedTags
      if (this.isEditing) {
        url = urls({route: 'user', id: this.isEditing})
        await axios.put(url, this.data)
      } else {
        url = urls({route: 'user'})
        await axios.post(url, this.data)
      }
      this.goUserList()
    },
    removeUser: async function () {
      await axios.delete(urls({route: 'user', id: this.isEditing}))
      this.goUserList()
    },
    readUser: async function (userID) {
      let req = await axios.get(urls({route: 'user', id: this.isEditing}))
      this.data = req.data.data
      for (var i in this.data.dedicatedTag) {
        const dTag = this.data.dedicatedTag[i]
        const mark = this.tags.find(tag => tag['id'] === dTag['id'])
        if (mark) {
          mark.is_dedicated = true
        }
      }
    },
    getClinic: async function () {
      let req = await axios.get(urls({route: 'clinic'}))
      this.clinics = req.data.data
    }
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/User/UserEdit.vue